module.exports = __webpack_public_path__ + "static/img/GT.712e04a6.png";